import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Tab } from 'src/app/shared/components/tabs/tab.model';
import { analyzeAndValidateNgModules } from '@angular/compiler';
import { UtilsService } from '../../../shared/services/utils.service';

@Component({
  selector: 'hs-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent implements OnInit {
  path: string;

  authTabs: Tab[] = [
    new Tab('login', 'Log in', '', ''),
    new Tab('signUp', 'Register', '', '')
  ];

  forgotPass = false;
  resetPass = false;
  selectedTab: Tab;

  returnUrl: string;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    private utils: UtilsService
  ) {

    this.utils.disableResponseCache();

    if (route.routeConfig.path === 'login') {
      this.selectedTab = this.authTabs[0];
    } else if (route.routeConfig.path === 'join') {
      this.selectedTab = this.authTabs[1];
    } else if (route.routeConfig.path === 'forgot-password') {
      this.selectedTab = this.authTabs[0];
      this.forgotPass = true;
    } else if (route.routeConfig.path === 'resetpass') {
      this.selectedTab = this.authTabs[0];
      this.resetPass = true;
    }
  }

  ngOnInit() {
    const returnUrlParam = 'returnUrl';
    this.returnUrl = this.route.snapshot.queryParams[returnUrlParam];
  }

  tabChanged(tab: Tab) {
    this.selectedTab = tab;
    if (this.selectedTab === this.authTabs[0]) {
      this.router.navigate(['/login'], { queryParams: { returnUrl: this.returnUrl }});
    } else {
      this.router.navigate(['/join'], { queryParams: { returnUrl: this.returnUrl }});
    }
  }

}
